import * as React from 'react'
import { Box, Typography } from '@mui/material'
import { formatNumber } from "@ui-seeker/utils"

import { NotAllowedBlock } from '@components'


export default function ratingColumn() {
	return {
		name: "rating", label: "Rating",
		options: {
			filter: false,
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Box sx={{ display: 'flex', alignItems: 'center'}}>
				{!!value && <Typography>
					{formatNumber(value, { decimals: 1})}
				</Typography>}

				{!value && <NotAllowedBlock />}
			</Box> 
		}
	}
}